export default {
  "fs.billingInfo": "Rechnungsadresse",
  "fs.date": "Datum",
  "fs.market": "Märkte",
  "fs.netSum": "Nettosumme (pro Markt)",
  "fs.orderReferenceShort": "Referenz-Code",
  "fs.orderNote": "Notiz",
  "fs.startup": "Startup (ZKS-Nummer)",
  "fs.region": "Region",
};
